export default __webpack_public_path__ + "7feeadc8157a9c660ae13f8dcc5487f5.png";